import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    searchTerm: '',
    period: null,
    itemCount: undefined,
    unblockStickerDialog: {
        open: false,
        data: undefined,
    },
};
const slice = createSlice({
    name: 'crossdocking/blocked',
    initialState,
    reducers: {
        setSearchTerm: (state, action) => {
            state.searchTerm = action.payload;
        },
        setPeriod: (state, action) => {
            state.period = action.payload;
        },
        setItemCount: (state, action) => {
            state.itemCount = action.payload;
        },
        openUnblockStickerDialog: (state, action) => {
            state.unblockStickerDialog = {
                open: true,
                data: action.payload,
            };
        },
        closeUnblockStickerDialog: (state) => {
            state.unblockStickerDialog = initialState.unblockStickerDialog;
        },
    },
});
export const { actions: crossdockBlockedActions, reducer: crossdockBlockedStateReducer } = slice;
